import { fetch } from '@utils/utils';

import * as T from '@modules/myItems/_myItemsTypes';
import { myItemsUrl } from '@modules/myItems/myItemsGrid';

const getMyItem =
  ({ addError }) =>
  async (id: string): Promise<T.MyItem> => {
    try {
      const response: any = await fetch(`${myItemsUrl}/${id}`, {
        method: 'GET',
        headers: new Headers({ 'Content-Type': 'application/json' })
      });

      const json: T.MyItem = await response.json();

      return json;
    } catch (err) {
      addError(err.message);
      return {};
    }
  };

const putMyItem =
  ({ addError, addSuccess }) =>
  async (id: string, note: string): Promise<boolean> => {
    try {
      const response: any = await fetch(`${myItemsUrl}/${id}`, {
        method: 'PUT',
        headers: new Headers({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({ note })
      });

      if (response.ok) {
        addSuccess('Předmět byl úspěšně uložen');
        return true;
      } else {
        addError('Předmět nebyl uložen');
        return false;
      }
    } catch (err) {
      addError(err.message);
      return false;
    }
  };

export { getMyItem, putMyItem };



// WEBPACK FOOTER //
// ./src/modules/myItems/_myItemsActions.ts